 
const theme = {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          'primary': '#3D5789',
        },
      }
    },
  }
  export default theme